import { Column,CreateDateColumn,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn,UpdateDateColumn,VersionColumn,} from 'typeorm';


@Entity('sku_price')
export class    SkuPrice {
  @PrimaryGeneratedColumn('increment', { name: 'sku_price_id' })
  skuPriceId: number;

    @Column('int',{
        name:'sku_id',
        nullable: false,

    })
    skuId:number

    @Column({
        name: 'effective_from_date',
        type: 'datetime',
        nullable: true,
    })
    effectiveFromDate: Date;

    @Column('decimal', {
        precision: 10, 
    scale: 2, 
        nullable: false,
        name: 'price',
    })
    price: number;

   

    @Column('varchar', {
        nullable: false,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;
    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag',
    })
    versionFlag: number;

    

    
    }

   

    
